export default __webpack_public_path__ + "static/media/lesnik_winter_a_05.d8050279.svg";